/* @ngInject */
const ask = (
  areaRequest,
  areaFormat,
  utils,
  areaLocal,
  areaData,
  toaster,
  areaLabels,
  valueHandler
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(areaLabels.ask.delete)) {
      try {
        const message = await areaRequest.delete(_id)
        toaster.message(message)
        utils.removeFromArray(areaData.myAreas, _id)
        if (_back) { utils.$back() }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_area, _back = false) => {
    let area = utils.copy(_area)
    area.id = areaLocal.getCurrentId()
    area = areaFormat.server(area)

    try {
      const response = await areaRequest.update(area)
      toaster.message(response.message)
      utils.updateFromArray(areaData.myAreas, response.area)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/ask.service.js